import React from 'react'
export default function Tag(props) {
  return (
    <div>
        <span  className='tag'>{props.tag}</span>
    </div>
  )
}
